import Form from "react-bootstrap/Form";
// import imgLogo from "../../../assets/images/Rocky/LOGOROCKY.png";
import { useState } from "react";
import logo from "../../../assets/images/Rocky/LOGOROCKY.png";

import { useNavigate } from "react-router-dom";
import { useForm } from "../../../utils/hooks/useForm";
import AccessUser from "../../../models/AccessUser";
import LoginService from "../../../services/loginService";
import { MessageToastify } from "../../../utils/funtions/MessageToastify";
import { ToastContainer } from "react-toastify";
import { Eye, EyeOff } from "lucide-react";

export const Login = () => {
  //Modal const
  //   const [show, setShow] = useState(false);
  //   const handleClose = () => setShow(false);

  //Variables for login, using useNavigate, formHtml, process and Access login
  const myNavigate = useNavigate();
  type formHtml = React.FocusEvent<HTMLFormElement>;
  const [inProcess, setProcess] = useState<boolean>(false);
  let { email, password, doubleLink, object } = useForm<AccessUser>(
    new AccessUser("", "")
  );
  const [showPassword, setShowPassword] = useState(false);
  const [isPasswordFocused, setIsPasswordFocused] = useState(false);
  const [isUserFocused, setIsUserFocused] = useState(false);

  //function to error the Token on the time, using when token is invalid or expired
  const handleTokenError = (e: any) => {
    MessageToastify("error", "El usuario no está activo.", 7000);
  };
  const toLowerCase = (text: string) => {
    return text.toLowerCase();
  };

  const converter = (object: any) => {
    object.email = toLowerCase(object.email);
    // eslint-disable-next-line no-self-assign
    object.password = object.password;
    // eslint-disable-next-line no-self-assign
    return object;
  };

  //function procces form create all log to use apiback
  const proccesForm = async (fh: formHtml) => {
    try {
      fh.preventDefault();
      setProcess(true);
      const formCurrent = fh.currentTarget;
      formCurrent.classList.add("was-validate");

      if (formCurrent.checkValidity() === false) {
        fh.preventDefault();
        fh.stopPropagation();
      } else {
        const lowerText = converter(object);
        const result = await LoginService.consumeService(lowerText);
        //comparte result access for enter to apiback, using url form apiBack.tsx
        if (result.access) {
          // const objJWT = jwt_decode(result.access);
          localStorage.setItem("access", result.access);
          localStorage.setItem("role", result.role);
          myNavigate("/home/main");
          setProcess(false);
        }
        if (result.error) {
          // cleanBoxs(formCurrent);
          const message = "Error: " + result.error;
          MessageToastify("error", message, 5000);
        }
      }
    } catch (e) {
      handleTokenError(e);
    }
  };

  return (
    <>
      <div
        className="min-h-screen bg-gradient-soft flex items-center justify-center p-4"
        style={{
          background:
            "linear-gradient($color-background-gradient-start, $color-background-gradient-end)",
        }}
      >
        <div
          className="login-wrapper relative p-4 rounded "
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            width: "450px",

            boxShadow: "0px 2px 9px rgba(0, 0, 0, 0.5)",
          }}
        >
          {/* Tooltip Usuario */}
          {isUserFocused && (
            <div className="absolute -top-10 left-1/4 -translate-x-1/2 bg-white dark:bg-gray-800 border border-golden rounded-lg px-3 py-2 shadow-xl animate-in zoom-in-95 duration-300 min-w-max">
              <div className="text-lg text-amber-800 dark:text-amber-800 font-medium flex items-center gap-2">
                ¡Bienvenido de vuelta!
              </div>
              <div className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-golden"></div>
            </div>
          )}

          {/* Tooltip Password */}
          {isPasswordFocused && (
            <div className="absolute -top-10 left-1/4 translate-x-1/2 bg-white dark:bg-gray-800 border border-golden rounded-lg px-3 py-2 shadow-xl animate-in zoom-in-95 duration-300 min-w-max">
              <div className="text-lg text-amber-800 dark:text-amber-800 font-medium flex items-center gap-2">
                ¡No compartas tu contraseña!
              </div>
              <div className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-golden"></div>
            </div>
          )}
          <div className="d-flex justify-content-center ">

            <div className="">
              <img
                src={logo}
                alt="Logo Rocky"
                style={{
                  width: "150px",
                  height: "auto",
                  marginLeft: "10px",
                }}
              />

            </div>

          </div>

          <h1
            style={{
              fontSize: "50px", // Tamaño grande
              fontWeight: "bold", // Negrilla
              color: "#d9931175", // Color específico
              fontFamily: "Arial, sans-serif", // Fuente diferente
              textAlign: "center", // Centrar el texto // Margen superior del 50%
              textShadow: "1px 1px 2px black", // Sombra negra alrededor del texto
            }}
          >
            Rocky
          </h1>

          <Form
            noValidate
            validated={inProcess}
            onSubmit={proccesForm}
            autoComplete="off"
          >
            <Form.Group controlId="email">
              <Form.Label className="text-black">Usuario:</Form.Label>
              <Form.Control
                required
                name="email"
                className="form-control"
                type="email"
                placeholder="Introduce tu usuario"
                value={email}
                onChange={doubleLink}
                autoComplete="off"
                onFocus={() => setIsUserFocused(true)}
                onBlur={() => setIsUserFocused(false)}
                style={{
                  color: "$color-primary-text",
                  borderRadius: "20px", // Ajusta el radio del borde aquí
                  border: "1px solid black", // Borde negro por defecto
                  textAlign: "center", // Centrar el texto
                  outline: "none", // Quitar la sombra azul
                }}
              />
              <Form.Control.Feedback type="invalid">
                El usuario es requerido para entrar.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="password" className="mt-3">
              <Form.Label className="text-black">Contraseña:</Form.Label>
              <div className="relative">
                <Form.Control
                  required
                  name="password"
                  className="form-control pr-10" // agrega espacio a la derecha
                  type={showPassword ? "text" : "password"}
                  placeholder="Introduce tu contraseña"
                  value={password}
                  onChange={doubleLink}
                  onFocus={() => setIsPasswordFocused(true)}
                  onBlur={() => setIsPasswordFocused(false)}
                  autoComplete="off"
                  style={{
                    color: "$color-primary-text",
                    borderRadius: "20px",
                    border: "1px solid black",
                    textAlign: "center",
                    outline: "none",
                  }}
                />

                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-10 top-1/4 -translate-y text-black-500 hover:text-black transition-colors "
                >
                  {showPassword ? (
                    <EyeOff className="w-7 h-7" />
                  ) : (
                    <Eye className="w-7 h-7" />
                  )}
                </button>

                <Form.Control.Feedback type="invalid">
                  La contraseña es requerida para ingresar.
                </Form.Control.Feedback>
              </div>
            </Form.Group>



            <button
              className="btn btn-block login-btn mt-4 w-100"
              type="submit"
              style={{
                backgroundColor: "$color-button-background",
                color: "$color-primary-text",
                borderRadius: "20px", // También puedes redondear el botón
                boxShadow: "0px 4px 6px #d9931175!important", // Sombra para el botón
              }}
            >
              Iniciar sesión
            </button>
          </Form>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};
